export type IAppendCurrentUrlBeforeRedirect = (
  link: HTMLAnchorElement | JQuery<HTMLAnchorElement>
) => void;

export function appendCurrentUrlBeforeRedirect(
  link: HTMLAnchorElement | JQuery<HTMLAnchorElement>
) {
  const targetUrl = $(link).attr('href') as string;
  const currentUrl = encodeURIComponent(window.location.href);
  const newUrl = `${targetUrl +
    window.DexeroCoreApp.getUrlSeperator(targetUrl)}returnUrl=${currentUrl}`;

  window.location.href = newUrl;
}
